import React, { Component } from 'react';
import GetListSucursales from './getListSucursales';
import GetListUbications from './getListUbications';
import GetNewUbication from './getNewUbication';
import GetUltimosPedidos from './getUltimosPedidos';
import GetInfoClient from './getInfoClient';
import GetTimer from './getTimer';
import GetEditFormaPago from './getEditFormaPago';
import GetEditDatosCliente from './getEditDatosCliente';
import GetDetallePedido from './getDetallePedido';
import GetTimerFijo from './getTimerFijo';
import GetModalNotificacion from './getModalNotificacion';
import GetMusic from './getMusic';


import '../css/getAppActive.css';

class getAppActive extends Component {
  constructor(){
    super();
    this.state = {
        modulo_modal : '',
        sub_modulo_modal : '',
        notificacion_modal :'',
        url_notificacion_modal :'',
        lat:localStorage.lat,
        lon:localStorage.lon,
        name:'Ubicación Actual',
        id_ubicacion : 0,
        id_forma_pago :0,
        id_datos_facturacion :0,
        token_pedido:'',
        estado_pedido : "",
        tiempo_estimado :"",
        id_estado_pedido :0,
        detalle:''
    }
  }
  get_token_pedido=(token_pedido,estado_pedido,tiempo_estimado,id_estado_pedido,detalle)=>{
    const token_pedido_global = this.state.token_pedido
    const id_estado_pedido_global = this.state.id_estado_pedido
    //if(id_estado_pedido_global){
    if(id_estado_pedido_global!==id_estado_pedido){
      localStorage.setItem("notificacion_pedido",detalle)
    }
    //}

    if(token_pedido===token_pedido_global){
      if(token_pedido_global){
        this.setState  ({
          token_pedido,
          estado_pedido,
          tiempo_estimado,
          id_estado_pedido,
          detalle
        })
      }
    }else{
      this.setState  ({
        token_pedido,
        estado_pedido,
        tiempo_estimado,
        id_estado_pedido,
        detalle
      })
    }

  }
  get_coordenadas=(lat,lon,name,id_ubicacion)=>{
    //localStorage.lat=lat
    //localStorage.lon=lon
    this.setState({
      name,id_ubicacion,lat,lon
    },
     ()=>{
       this.get_go_to('')
     })

  }
  get_go_to =(modulo_modal)=>{
    this.setState({
      modulo_modal
    })
  }
  get_salir_notificacion=()=>{
    this.setState({
      notificacion_modal:"",url_notificacion_modal:""
    })
  }
  get_go_to_sub =(sub_modulo_modal)=>{
    this.setState({
      sub_modulo_modal
    })
  }
  get_new_notificacion=(notificacion_modal,url_notificacion_modal)=>{
    this.setState({
      notificacion_modal,url_notificacion_modal
    })
  }
  render() {
    const modulo_modal = this.state.modulo_modal
    const sub_modulo_modal = this.state.sub_modulo_modal
    const notificacion_modal = this.state.notificacion_modal
    const name = this.state.name
    let dir_modulo_modal
    let dir_sub_modulo_modal
    let dir_notificacion_modulo_modal
    let dir_modulo_sucursales

    if(notificacion_modal==='notificacion_global'){
        dir_sub_modulo_modal = <div id="loader_msg_notificacion" className="loader_msg_notificacion loader_msg_notificacion-default is-active" data-text="">
                                <GetModalNotificacion get_salir_notificacion={this.get_salir_notificacion} url_notificacion_modal={this.state.url_notificacion_modal} />
                               </div>
    }

    if(sub_modulo_modal==='editformapago'){
        dir_sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetEditFormaPago  token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(sub_modulo_modal==='editdatosclientes'){
        dir_sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetEditDatosCliente  token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  get_go_to_sub={this.get_go_to_sub} />
                               </div>
    }
    if(sub_modulo_modal==='editdatospedido'){
        const token_pedido = this.state.token_pedido
        if(token_pedido){
          dir_sub_modulo_modal = <div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                                <GetDetallePedido separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase}
                                 file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}
                                 lat={this.state.lat}  lon={this.state.lon} token_pedido={this.state.token_pedido}
                                id_estado_pedido={this.state.id_estado_pedido} estado_pedido={this.state.estado_pedido}
                                tiempo_estimado={this.state.tiempo_estimado} get_token_pedido={this.get_token_pedido}
                                token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}
                                 get_go_to_sub={this.get_go_to_sub} />
                               </div>
        }
    }//isc222.mp3
    if(modulo_modal==='ubicacion'){
      dir_modulo_modal = <div id="loader_msg" className="loader_msg loader_msg-default is-active" data-text="">
                          <GetListUbications id_ubicacion={this.state.id_ubicacion} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to} get_coordenadas={this.get_coordenadas} />
                          </div>
    }
    if(modulo_modal==='newubicacion'){
      dir_modulo_modal = <div id="loader_msg" className="loader_msg loader_msg-default is-active" data-text="">
                        <GetNewUbication get_coordenadas={this.get_coordenadas} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to}/>
                        </div>
    }
    if(modulo_modal==='ultimospedidos'){
      dir_modulo_modal = <React.Fragment><GetUltimosPedidos token={this.props.token} dir_url={this.props.dir_url}/></React.Fragment>
      dir_modulo_sucursales =<React.Fragment><GetListSucursales sucursal={this.props.sucursal}  separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal} token_Client={this.props.token_Client} name={this.state.name} lat={this.state.lat}  lon={this.state.lon}  token={this.props.token} dir_url={this.props.dir_url}/></React.Fragment>
    }
    if(modulo_modal==='infoclient'){
      dir_modulo_modal = <div id="loader_msg" className="loader_msg loader_msg-default is-active" data-text="">
                          <GetInfoClient setCerrarSesion={this.props.setCerrarSesion}  get_go_to_sub={this.get_go_to_sub} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to}/>
                          </div>
      dir_modulo_sucursales =<React.Fragment><GetListSucursales sucursal={this.props.sucursal}  separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}  token_Client={this.props.token_Client} name={this.state.name} lat={this.state.lat} lon={this.state.lon} token={this.props.token} dir_url={this.props.dir_url}/></React.Fragment>
    }
    if(modulo_modal==='infopedido'){
      //dir_modulo_modal = <React.Fragment><GetInfoPedido/></React.Fragment>
      dir_modulo_sucursales =<React.Fragment><GetListSucursales sucursal={this.props.sucursal}  separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}  token_Client={this.props.token_Client} name={this.state.name} lat={this.state.lat}  lon={this.state.lon} token={this.props.token} dir_url={this.props.dir_url}/></React.Fragment>
    }
    if(modulo_modal===''){
      dir_modulo_sucursales =<React.Fragment><GetListSucursales id_mesa={this.props.id_mesa} sucursal={this.props.sucursal}  separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x250={this.props.file_250x250} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}  token_Client={this.props.token_Client} name={this.state.name} lat={this.state.lat} lon={this.state.lon} token={this.props.token} dir_url={this.props.dir_url}/></React.Fragment>
    }
    let dir_alert
    if(localStorage.getItem("notificacion_pedido")){
      dir_alert =<React.Fragment>
                {(window.Android) ?
                  window.Android.showToast(this.state.detalle)
                :<GetMusic/>}
                </React.Fragment>
      localStorage.setItem("notificacion_pedido","")
    }

    return (
      <React.Fragment>
        <div className="cssversion_menu cssversion_colorprimario">
          <div className="cssversion_pw100 cssversion_ph10 cssversion_colorblanco" style={{"display":"flex"}}>
            <div className="cssversion_pw15 cssversion_contentCenter" onClick={ () => this.get_go_to("infoclient")}>
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  />
            </div>
            <div className="cssversion_pw70 cssversion_contentCenter" onClick={ () => this.get_go_to("ubicacion")}>
              <span className="span-global-link">{name}</span>
            </div>
            <div className="cssversion_pw15 cssversion_contentCenter" onClick={ () => this.get_go_to("ubicacion")}>
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') } />
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_ph70" style={{"display":"flex"}}>
            {dir_modulo_sucursales}
          </div>
          <div className="cssversion_pw100 cssversion_ph20 cssversion_colorblanco cssversion_contentCenter" style={{"borderRadius": "30px 30px 0px 0px","display":"flex"}}>
            <GetTimer  id_estado_pedido={this.state.id_estado_pedido} estado_pedido={this.state.estado_pedido} tiempo_estimado={this.state.tiempo_estimado} get_go_to_sub={this.get_go_to_sub} get_token_pedido={this.get_token_pedido} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  />
          </div>
        </div>
        {dir_modulo_modal}
        {dir_sub_modulo_modal}
        {dir_notificacion_modulo_modal}
        <GetTimerFijo get_new_notificacion={this.get_new_notificacion} token={this.props.token} dir_url={this.props.dir_url}/>
        {dir_alert}
      </React.Fragment>
    )
  }

/*  <div className="grid colorblanco grid-bleed ph100 pw100" style={{"letterSpacing":"0em","wordSpacing":"0em"}}>
    <div className="col-12">
      <div className="grid grid-bleed ph100 pw100" style={{"margin":"0px","letterSpacing":"0em","wordSpacing":"0em"}}>
        <div className="content-global colorprimario">
          <div className="header-global pxh50 pw100 colorblanco">
            <div className="grid grid-bleed pxh50" style={{"margin":"0px","letterSpacing":"0em","wordSpacing":"0em"}}>
              <div className="col-2 col-grid centerContent" onClick={ () => this.get_go_to("infoclient")}>
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') }  />
              </div>
              <div className="col-8 col-grid centerContent" onClick={ () => this.get_go_to("ubicacion")}>
                <span className="span-global-link">
                  {name}
                </span>
              </div>
              <div className="col-2 col-grid centerContent" onClick={ () => this.get_go_to("ubicacion")}>
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') } />
              </div>
            </div>
          </div>
          <div className="inner-global pw100" style={{"zIndex":"1"}}>
            {dir_modulo_sucursales}
          </div>
          <div className="footer-global pxh100 pw100 colorblanco" style={{"borderRadius": "30px 30px 0px 0px"}}>
            <GetTimer  id_estado_pedido={this.state.id_estado_pedido} estado_pedido={this.state.estado_pedido} tiempo_estimado={this.state.tiempo_estimado} get_go_to_sub={this.get_go_to_sub} get_token_pedido={this.get_token_pedido} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  />
          </div>
        </div>
      </div>
    </div>
    {dir_modulo_modal}
    {dir_sub_modulo_modal}
    {dir_notificacion_modulo_modal}
    <GetTimerFijo get_new_notificacion={this.get_new_notificacion} token={this.props.token} dir_url={this.props.dir_url}/>
    {dir_alert}
  </div>*/
  /**/
















  /*

   <div className="div_global_appactive">
      <div className="grid-container-appactive">
        <div className="div_global_menu">
          <div className="div_global_user">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/1388560951582004484-128.png') } onClick={ () => this.get_go_to("infoclient")} />
          </div>
          <div className="div_global_ubicacion" onClick={ () => this.get_go_to("ubicacion")}>
            <span className="span-global-link">
              {name}
            </span>
          </div>
          <div className="div_global_ubicacion_logo" onClick={ () => this.get_go_to("ubicacion")}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/9478791231582004484-128.png') } />
          </div>
        </div>
        <div className="div_global_sucursales">{dir_modulo_sucursales}</div>
        <div className="div_global_bottom">
          <GetTimer  id_estado_pedido={this.state.id_estado_pedido} estado_pedido={this.state.estado_pedido} tiempo_estimado={this.state.tiempo_estimado} get_go_to_sub={this.get_go_to_sub} get_token_pedido={this.get_token_pedido} token_Client={this.props.token_Client} token={this.props.token} dir_url={this.props.dir_url}  />
        </div>
        {dir_modulo_modal}
        {dir_sub_modulo_modal}
        {dir_notificacion_modulo_modal}
        <GetTimerFijo get_new_notificacion={this.get_new_notificacion} token={this.props.token} dir_url={this.props.dir_url}/>
        {dir_alert}
      </div>
    </div>*/
  componentDidMount (){
    //BUSCAR NOTIFICACIONES
  }
}
export default getAppActive;
